import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'resource',
    template: require('./resource.component.html')
})
export class ResourceComponent implements OnInit {
    @Input() type: string;
    @Input() id: number;
    @Input() attr: string;

    autoplay = true;
    hidepdf = false;

    ngOnInit() {
        if (this.attr) {
            if (this.attr.indexOf("no-autoplay") >= 0) {
                this.autoplay = false;
            }
            if (this.attr.indexOf("hide-pdf") >= 0) {
                this.hidepdf = true;
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/resource.component.ts